import type { SubscriptionTier } from "./tiers";
import { PRICE_INDEX_API_LIMITS } from "../price-index/api";

export const TRIAL_DAYS = 14;

export const CATALOGUE_TIERS = ["free", "pro", "enterprise"] as const;
export type CatalogueTier = (typeof CATALOGUE_TIERS)[number];

export function isCatalogueTier(tier: SubscriptionTier): tier is CatalogueTier {
  return CATALOGUE_TIERS.some((catalogueTier) => catalogueTier === tier);
}

export const TIER_DESCRIPTIONS: Record<CatalogueTier, string> = {
  free: "Buy and sell on Repackify at no monthly cost.",
  pro: "Collect free pallets, cores, gaylords and totes, and bid on recycle loads.",
  enterprise: "A custom commercial agreement for enterprise accounts.",
};

export const TIER_VALUE_PROPS: Record<CatalogueTier, string[]> = {
  free: [
    "Unlimited listings and locations",
    "Buy & sell packaging",
    "Orders, quotes & invoices",
    "AI assistant",
    "Email support",
  ],
  pro: [
    "Everything in Free",
    "Claim free pickups: packaging businesses want gone, yours at no cost",
    "Bid on recycle listings: offer to pay for a load or charge to haul it",
    "Unlimited team seats (admins are always free)",
    "Unlimited price data API calls",
  ],
  enterprise: ["Everything in Pro", "Custom commercial terms"],
};

export type ComparisonValue = boolean | string;

export type ComparisonFeature = { name: string } & Record<
  CatalogueTier,
  ComparisonValue
>;

export interface ComparisonCategory {
  name: string;
  features: ComparisonFeature[];
}

export const PLAN_COMPARISON: ComparisonCategory[] = [
  {
    name: "Marketplace",
    features: [
      {
        name: "Buy, sell, quotes, orders and invoices",
        free: true,
        pro: true,
        enterprise: true,
      },
      {
        name: "Browse free pickup and recycle listings",
        free: true,
        pro: true,
        enterprise: true,
      },
      {
        name: "Claim free pickups",
        free: false,
        pro: true,
        enterprise: true,
      },
      {
        name: "Bid on recycle listings (pay for a load or charge to haul it)",
        free: false,
        pro: true,
        enterprise: true,
      },
    ],
  },
  {
    name: "Team",
    features: [
      {
        name: "Team seats (admins are always free)",
        free: "—",
        pro: "Unlimited",
        enterprise: "Unlimited",
      },
    ],
  },
  {
    name: "Price data",
    features: [
      {
        name: "Price data API calls with a key",
        free: `${PRICE_INDEX_API_LIMITS.freePerDay.toLocaleString("en-US")} a day`,
        pro: "Unlimited",
        enterprise: "Unlimited",
      },
    ],
  },
];
